import React from 'react';
import './closeBikeNetworkInfo-button.scss';

interface CloseBikeNetworkInfoProps {
    title: string;
  }

const CloseBikeNetworkInfo: React.FC<CloseBikeNetworkInfoProps> = ({title}: any) => {
    return (
        <div className="close-bike-network-button"> {title}</div>
    );
};

export default CloseBikeNetworkInfo;
